export enum ESessions {
    UserInfo = 'UserInfo'
}
